import { BaseAIService } from './BaseAIService';
import { OpenAIService } from './providers/OpenAIService';
import { AzureOpenAIService } from './providers/AzureOpenAIService';
import { ClaudeService } from './providers/ClaudeService';
import { OllamaService } from './providers/OllamaService';
import { VLLMService } from './providers/VLLMService';
import { LMStudioService } from './providers/LMStudioService';
import { 
  AIProvider, 
  OpenAIConfig, 
  AzureOpenAIConfig, 
  ClaudeConfig, 
  OllamaConfig, 
  VLLMConfig, 
  LMStudioConfig,
  BaseConfig
} from './types';

export type AIProviderType = AIProvider | null;

export class AIServiceFactory {
  private static instance: AIServiceFactory;
  private instances: Map<string, BaseAIService> = new Map();

  private constructor() {}

  static getInstance(): AIServiceFactory {
    if (!AIServiceFactory.instance) {
      AIServiceFactory.instance = new AIServiceFactory();
    }
    return AIServiceFactory.instance;
  }

  static getService(provider: AIProviderType, config?: BaseConfig): BaseAIService | null {
    if (!provider) {
      return null;
    }
    
    return AIServiceFactory.getInstance().getService(provider, config);
  }

  private getService(provider: AIProvider, config: BaseConfig = {}): BaseAIService {
    // 生成缓存键，包含提供商和配置哈希
    const cacheKey = `${provider}-${JSON.stringify(config)}`;
    
    // 检查缓存
    if (this.instances.has(cacheKey)) {
      return this.instances.get(cacheKey)!;
    }

    // 创建新的服务实例
    let service: BaseAIService;
    
    switch (provider) {
      case 'openai':
        service = new OpenAIService(config as OpenAIConfig);
        break;
      case 'azureopenai':
        service = new AzureOpenAIService(config as AzureOpenAIConfig);
        break;
      case 'claude':
        service = new ClaudeService(config as ClaudeConfig);
        break;
      case 'ollama':
        service = new OllamaService(config as OllamaConfig);
        break;
      case 'vllm':
        service = new VLLMService(config as VLLMConfig);
        break;
      case 'lmstudio':
        service = new LMStudioService(config as LMStudioConfig);
        break;
      default:
        throw new Error(`不支持的 AI 提供商: ${provider}`);
    }

    // 缓存实例
    this.instances.set(cacheKey, service);
    return service;
  }
  
  // 清除缓存实例（用于测试或重置）
  static clearInstances(): void {
    AIServiceFactory.getInstance().instances.clear();
  }
} 